/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ImportJsonTranslationDto } from '../../models/import-json-translation-dto';
import { ImportJsonTranslationResponseDto } from '../../models/import-json-translation-response-dto';

export interface ImportJsonTranslationsControllerImportJsonTranslations$Params {
      body: ImportJsonTranslationDto
}

export function importJsonTranslationsControllerImportJsonTranslations(http: HttpClient, rootUrl: string, params: ImportJsonTranslationsControllerImportJsonTranslations$Params, context?: HttpContext): Observable<StrictHttpResponse<ImportJsonTranslationResponseDto>> {
  const rb = new RequestBuilder(rootUrl, importJsonTranslationsControllerImportJsonTranslations.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ImportJsonTranslationResponseDto>;
    })
  );
}

importJsonTranslationsControllerImportJsonTranslations.PATH = '/import-json-translations/import';
